module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_9006.c8d897d1.png";